import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'reminder-notification-list',
  templateUrl: './reminder-notification-list.component.html',
  styleUrls: ['./reminder-notification-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReminderNotificationListComponent implements OnInit {
  reminderList = [];
  todayDate = new Date();
  minimumDate = new Date();
  AttentionCount;
  loading = true;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.todayDate.setHours(23, 59, 59);
    this.minimumDate.setFullYear(1980);
  }
  SetUpdatedList(list) {
    this.reminderList = list;
    this.AttentionCount = this.reminderList.filter(
      (x) => x.effective_date == null || x.effective_date == undefined || (x.effective_date < this.todayDate && x.effective_date > this.minimumDate)
    );
    this.loading = false;
    this.cd.detectChanges();
  }
}
